export const SIGNUP_LINK_BASE = "/signup";
export const LOGIN_LINK_BASE = "/auth/login";

/**
 * Returns the URL path of a given URL.
 * @param {URL} url - The URL object.
 * @returns {string} - The URL path.
 */
function getUrlPath(url) {
  return [url.pathname, url.search, url.hash].join("");
}

/**
 * Generates the sign-up URL with an optional return URL.
 * @param {URL} returnUrl - The return URL.
 * @returns {string} - The sign-up URL.
 */
export function getSignUpUrl(returnUrl) {
  const signUpUrl = new URL(SIGNUP_LINK_BASE, window.location.href);

  if (returnUrl) {
    signUpUrl.searchParams.append("next_action", getUrlPath(returnUrl));
  }

  return getUrlPath(signUpUrl);
}

/**
 * Generates the log-in URL with an optional return URL.
 * @param {URL} returnUrl - The return URL.
 * @returns {string} - The log-in URL.
 */
export function getLogInUrl(returnUrl) {
  const logInUrl = new URL(LOGIN_LINK_BASE, window.location.href);
  if (returnUrl) {
    logInUrl.searchParams.append("next_action", getUrlPath(returnUrl));
  }
  return getUrlPath(logInUrl);
}
